import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { appStore, permissionStore } from "@/hooks";
import { DetailsPanel, PanelCard, TextButton } from "@/components/common";
import {
  SaveArtifactInputs,
  SaveArtifactButtons,
  ArtifactHealth,
} from "@/components/artifact/save";

/**
 * Allows for creating and editing artifacts.
 */
const __default__ = {
  name: "SaveArtifactPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), {
    panel: "saveArtifact",
    "data-cy": "panel-artifact-save"
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        text: "",
        label: "View Artifact",
        icon: "artifact",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).openDetailsPanel('displayArtifact')))
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(PanelCard), {
        title: "Save Artifact",
        borderless: ""
      }, {
        actions: _withCtx(() => [
          _createVNode(_unref(SaveArtifactButtons))
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(SaveArtifactInputs))
        ]),
        _: 1
      }),
      (_unref(permissionStore).isNASA)
        ? (_openBlock(), _createBlock(_unref(ArtifactHealth), { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})